export default __webpack_public_path__ + "static/media/information--lane-control-right-turn--g1.5fa2157c.png";